import { render, staticRenderFns } from "./courserList.vue?vue&type=template&id=652d021e&scoped=true"
import script from "./courserList.vue?vue&type=script&lang=js"
export * from "./courserList.vue?vue&type=script&lang=js"
import style0 from "./courserList.vue?vue&type=style&index=0&id=652d021e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652d021e",
  null
  
)

export default component.exports